import { defineCopy } from "@tami/core/intl";

import { PLAN_PRESENTATION_COPY_EN_US } from "./en-us/plan-presentation.copy";
import { PLAN_PRESENTATION_COPY_ES_ES } from "./es-es/plan-presentation.copy";

/** Textos da apresentação dos planos (cards de preço). Só web. */
export const PLAN_PRESENTATION_COPY_PT_BR = {
  fallbackPitchFree:
    "Acesso gratuito às funcionalidades básicas. Sem surpresas — e sem cartão.",
  fallbackPitchPaid: "Todo o produto, sem as travas do plano gratuito.",
  badge: {
    onRequest: "Sob medida",
    free: "100% Free",
    highlighted: "Muito mais Tãmi",
    default: "Sem travas",
  },
  ctaFree: "Comece agora grátis!",
  ctaSubscribe: (shortPlanName: string): string => `Assinar o ${shortPlanName}`,
} as const;

export const PLAN_PRESENTATION_COPY = defineCopy(PLAN_PRESENTATION_COPY_PT_BR, {
  "en-US": PLAN_PRESENTATION_COPY_EN_US,
  "es-ES": PLAN_PRESENTATION_COPY_ES_ES,
});
